<template>
	<v-menu close-on-click :close-on-content-click="false">
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="mr-2 mb-4" v-bind="attrs" v-on="on">
				<v-icon class="mr-1"> mdi-magnify</v-icon>絞り込み
			</v-btn>
		</template>
		<v-card width="300px">
			<v-app-bar dark color="primary" height="32px" elevation="0">
				<h6 class="text-body-2 font-weight-bold white--text">絞り込み</h6>
			</v-app-bar>
			<v-sheet class="pa-2" elevation="0">
				<h6 class="text-body-2 font-weight-bold mb-2">工事データ絞り込み</h6>
				<v-select
					label="期"
					:items="periods"
					v-model="q.period_id_eq"
					class="mt-4"
					item-text="name"
					item-value="id_eq"
					outlined
					dense
					hide-details
				/>
				<v-menu
					ref="dateRangeMenu"
					v-model="dateRangeMenu"
					:close-on-content-click="false"
					:return-value.sync="dateRange"
					transition="scale-transition"
					offset-y
					min-width="auto"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="datesText"
							label="工事日"
							class="mt-4"
							clearable
							outlined
							dense
							readonly
              hide-details
							v-bind="attrs"
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker
						class="date-picker"
						v-model="dateRange"
						no-title
						scrollable
						range
						locale="ja-JP"
					>
						<v-spacer />
						<v-btn text color="grey" @click="dateRangeMenu = false"> キャンセル </v-btn>
						<v-btn text color="primary" @click="changeDateRange('dateRange', 'order_date')">
							決定
						</v-btn>
					</v-date-picker>
				</v-menu>

				<v-text-field
					label="工事名"
					v-model="q.name_cont"
					class="mt-4"
					outlined
					dense
					hide-details
				/>

				<h6 class="text-body-2 font-weight-bold mt-4">作業者データ絞り込み</h6>
				<v-select
					label="所属"
					:items="associated_companies"
					v-model="q.associated_company_id_eq"
					class="mt-4"
					item-text="name"
					item-value="id_eq"
					outlined
					dense
					hide-details
				/>
				<v-text-field
					label="作業者名"
					v-model="worker_q.name_cont"
					class="mt-4"
					outlined
					dense
					hide-details
				/>
				<v-row class="mt-4" no-gutters justify="center">
					<v-btn class="ma-1" @click="search" color="secondary">
						<v-icon class="mr-2">mdi-magnify</v-icon>
						検索</v-btn
					>
					<v-btn class="ma-1" @click="resetForm" outlined color="secondary">
						<v-icon class="mr-2">mdi-autorenew</v-icon>
						クリア</v-btn
					>
				</v-row>
			</v-sheet>
		</v-card>
	</v-menu>
</template>

<script>
export default {
	props: {
		query: {
			type: Object,
			default: () => {
				return {}
			},
		},
		work_query: {
			type: Object,
			default: () => {
				return {}
			},
		},
		constructions: {
			type: Array,
			default: () => {
				return []
			},
		},
		periods: {
			type: Array,
			default: () => {
				return []
			},
		},
		associated_companies: {
			type: Array,
			default: () => {
				return []
			},
		},
	},
	components: {},
	data() {
		return {
			q: {
				period_id_eq: null,
				name_cont: null,
				date_gteq: null,
				date_lteq: null,
			},
			worker_q: {
				associated_company_id_eq: null,
				name_cont: null,
			},
			dateRange: [],
			dateRangeMenu: false,
		}
	},
	methods: {
		search() {
			this.$emit("search", { q: this.q, worker_q: this.worker_q })
		},
		resetForm() {
			this.$refs.form.reset()
		},
		changeDateRange(dateRange, queryName) {
			if (this[dateRange].length) {
				const firstDate = this[dateRange][0]
				const lastDate = this[dateRange][this[dateRange].length - 1]
				if (firstDate > lastDate) {
					this.q[`${queryName}_gteq`] = lastDate
					this.q[`${queryName}_lteq`] = firstDate
				} else {
					this.q[`${queryName}_gteq`] = firstDate
					this.q[`${queryName}_lteq`] = lastDate
				}
			} else {
				this.q[`${queryName}_gteq`] = null
				this.q[`${queryName}_lteq`] = null
			}
			this.$refs[`${dateRange}Menu`].save(this[dateRange])
		},
	},
	computed: {
		datesText: {
			get() {
				return this.dateRange.length
					? this.dateRange.map((d) => common.formatDate(d)).join(" ~ ")
					: null
			},
			set(newVal) {
				this.dateRange = []
				this.changeDateRange("dateRange", "order_date")
				return
			},
		},
	},

	watch: {
		query: {
			handler(newVal) {
				this.q = newVal
			},
			deep: true,
		},
		work_query: {
			handler(newVal) {
				this.worker_q = newVal
			},
			deep: true,
		},
	},
}
</script>
